import * as React from 'react';
import { st, classes } from './CopyUrlButton.st.css';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { SocialBarIcon } from '../SocialBar/SocialBarIcon';
import { getButtonIcon } from './CopyUrlButton.utils';
import { delay } from '../utils';
import { SocialBarThemes } from '../SocialBar/consts';
export const CopyUrlButton = ({ socialBarTheme = SocialBarThemes.light, className, 'data-hook': dataHook, tooltipText, url, successText, onClick, icon, ...otherProps }) => {
    const [success, setSuccess] = React.useState(false);
    const { mobile } = useTPAComponentsContext();
    const onButtonClick = React.useCallback(async (event) => {
        if (success) {
            return;
        }
        await navigator.clipboard.writeText(url);
        if (onClick) {
            onClick(event);
        }
        setSuccess(true);
        await delay(5000);
        setSuccess(false);
    }, [success, url, onClick]);
    return (React.createElement(SocialBarIcon, { className: st(classes.root, { theme: socialBarTheme, mobile }, className), "data-hook": dataHook, tooltip: success && !mobile ? null : tooltipText, socialBarTheme: socialBarTheme, icon: getButtonIcon({
            mobile,
            successText,
            success,
            icon,
        }), as: "button", ...otherProps, onClick: onButtonClick, hasLiveRegion: true }));
};
//# sourceMappingURL=CopyUrlButton.js.map